(function () {
  var caret =
    '<span class="svg-wrapper icon-caret icon-caret--forward" aria-hidden="true">' +
    '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11 5.5L7 9.5L3 5.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
    '</span>';

  function insertDrawerShortlist(drawer, node) {
    if (!drawer || !node) return;
    var menu = drawer.querySelector('.menu-drawer__menu');
    if (menu) {
      menu.appendChild(node);
      return;
    }
    var util = drawer.querySelector('.menu-drawer__utility-links');
    if (util) { util.parentNode.insertBefore(node, util); return; }
    var featured = drawer.querySelector('.menu-drawer__featured-content');
    if (featured) { featured.parentNode.insertBefore(node, featured); return; }
    var backdrop = drawer.querySelector('.menu-drawer__backdrop');
    if (backdrop) { backdrop.parentNode.insertBefore(node, backdrop); return; }
    var nav = drawer.querySelector('.menu-drawer__navigation');
    if (nav) nav.insertAdjacentElement('afterend', node);
  }

  function ensureDrawerShortlist() {
    var drawer = document.querySelector('#header-component .menu-drawer');
    if (!drawer) return;
    if (drawer.querySelector('.ths-drawer-shortlist')) {
      document.dispatchEvent(new CustomEvent('ths:shortlist-sync'));
      return;
    }
    var tpl = document.getElementById('ths-drawer-shortlist');
    if (tpl && tpl.content) {
      insertDrawerShortlist(drawer, tpl.content.cloneNode(true));
    } else {
      var row = document.createElement('li');
      row.className = 'menu-drawer__list-item menu-drawer__list-item--divider ths-drawer-shortlist menu-drawer__animated-element';
      row.innerHTML =
        '<button type="button" class="menu-drawer__menu-item menu-drawer__menu-item--mainlist menu-drawer__animated-element focus-inset" data-ths-wishlist-open aria-label="Open shortlist">' +
        '<span class="menu-drawer__menu-item-text wrap-text">SHORTLIST<span class="ths-drawer-shortlist__count" data-ths-wishlist-count aria-hidden="false">(0)</span></span>' +
        caret +
        '</button>';
      insertDrawerShortlist(drawer, row);
    }
    document.dispatchEvent(new CustomEvent('ths:shortlist-sync'));
  }

  function boot() {
    ensureDrawerShortlist();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', ensureDrawerShortlist);
})();
